<template>
    <div class="SystemsDashboard">
        <div class="spacer" />
        <button class="close-button" @click="$emit('close')">Close</button>

        <div v-if="groupedJourneys" class="multiple-groups-system-wrapper">
            <SystemItemsGroup v-for="group in system.groups" :key="group.name" :group="group" :system-id="system.id" />
        </div>

        <div v-else class="no-groups-system-wrapper">
            <SystemItem
                v-for="(journey, index) in system.journeys"
                :key="journey.name"
                :journey="journey"
                :is-single-journey="system.journeys.length === 1"
                :index="index"
                :system-id="system.id"
            />
        </div>

        <div class="spacer" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SystemItemsGroup from './SystemItemsGroup';
import SystemItem from './SystemItem';

export default {
    components: {
        SystemItemsGroup,
        SystemItem
    },

    props: {
        systemId: {
            type: String,
            required: true,
            default: ''
        }
    },

    computed: {
        ...mapGetters({
            getSystemById: 'moduleCourse/getSystemById'
        }),

        system() {
            return this.getSystemById(this.systemId);
        },

        groupedJourneys() {
            return this.system.type === 'grouped';
        }
    }
};
</script>

<style lang="scss" scoped>
.SystemsDashboard {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: column;
    background: white;
    margin-left: calc(calc(100vw - 965px) / -2);
    padding-right: calc(calc(100vw - 965px) / 2);
    position: relative;
    .close-button {
        border: none;
        background: white;
        color: #727272;
        cursor: pointer;
        outline: none;
        position: absolute;
        top: 2em;
        right: 3em;
    }
    .multiple-groups-system-wrapper {
        width: 100%;
        display: flex;
        align-items: flex-end;
        flex-direction: column;
    }
    .spacer {
        height: 3em;
        width: 100%;
    }
}
</style>
